var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg13 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "13")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M54.82,45.52c0-2.28.07-4.56,0-6.84-.06-1.32.49-1.71,1.69-1.66,2.56.11,5.12.22,7.68.22,2.34,0,2.38-.12,2.41-2.41q0-2.05.12-4.1c0-.37-.22-.87.21-1.09s.85.18,1.2.45q4.26,3.28,8.5,6.58c3.41,2.66,6.79,5.34,10.21,8,.71.55,1.09,1,.19,1.71q-9.42,7.36-18.83,14.72c-.37.29-.71,1-1.27.59s-.3-.94-.31-1.44c0-1.48-.09-3,0-4.45s-.33-1.92-1.81-1.86c-2.85.11-5.7,0-8.56,0-1.2,0-1.61-.42-1.58-1.61.07-2.28,0-4.56,0-6.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.92,57.53a3.26,3.26,0,0,1-1.19,2.57Q16.06,66.8,9.36,73.49a4,4,0,0,1-5.17.29C2.35,72.14,2,69.71,3.55,68c2.19-2.39,4.51-4.65,6.81-6.95s4.54-4.46,6.82-6.69a3.67,3.67,0,0,1,4.29-.63A4.16,4.16,0,0,1,23.92,57.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.42,40.08a3.19,3.19,0,0,1-2.59-1.27C12.52,34.6,8.22,30.39,4,26.12a4.06,4.06,0,0,1-.15-6c1.6-1.64,4-1.55,5.9.3Q16.07,26.68,22.34,33c1.31,1.32,2,2.82,1.14,4.77C22.7,39.41,21.43,40.05,19.42,40.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.94,15.12c4.39,0,8.78,0,13.17,0,1.39,0,1.93.4,1.84,1.87-.24,3.9.67,3.57-3.76,3.57l-24.11,0c-1.66,0-2.2-.53-2.18-2.25,0-3.42-.5-3.11,3.07-3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.79,75.88c-4.44,0-8.88,0-13.32,0-1.24,0-1.69-.34-1.65-1.66.14-3.91.16-3.8,4.06-3.64,5,.2,10,.07,15,.07,3.23,0,6.47,0,9.7,0,.9,0,1.33.38,1.33,1.34,0,4.65.5,3.85-3.67,3.9C46.42,75.91,42.61,75.88,38.79,75.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.18,63.94a4.43,4.43,0,0,1,4.67-4.4,4.65,4.65,0,1,1-.11,9.31A4.58,4.58,0,0,1,41.18,63.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.77,47a5.06,5.06,0,0,1,4.74,5.07c0,2-2.4,4.37-4.35,4.3-3.14-.11-5-2-5-4.86A4.5,4.5,0,0,1,45.77,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.85,56.18a4,4,0,0,1-4.28-4c0-3,1.76-5,4.38-5.07a4.64,4.64,0,0,1,4.85,4.67C37,54.37,34.79,56.18,31.85,56.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.53,26.95a4.5,4.5,0,0,1,4.56-4.73,5,5,0,0,1,4.75,4.7,4.69,4.69,0,0,1-4.45,4.53C29.43,31.47,27.53,29.71,27.53,26.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.69,31.29a4.2,4.2,0,0,1-4.51-4.23,4.6,4.6,0,1,1,9.19-.46A4.45,4.45,0,0,1,45.69,31.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.53,39.41a4.32,4.32,0,0,1,4.59-4.59c2.44,0,4.91,2.07,4.65,4.23-.33,2.76-1.64,4.75-4.74,4.83A4.2,4.2,0,0,1,27.53,39.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.51,63.93c0-2.55,2-4.27,4.93-4.27a4.6,4.6,0,0,1,4.27,4.64,4.69,4.69,0,0,1-4.57,4.59A4.84,4.84,0,0,1,27.51,63.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.84,43.78c-2.91,0-4.57-1.56-4.56-4.32s1.64-4.59,4.17-4.57c2.86,0,5.12,2,5,4.69A4.23,4.23,0,0,1,45.84,43.78Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg13, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/13.4ec2db4c.svg";
export { ForwardRef as ReactComponent };